import React, { useState, useEffect } from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import Icon from '../../icons';
import './formTags_style.css';
import { addClass, removeClass, getInputWidth } from '../../common/util';

const FormTags = (field) => {

    const { suggestions } = field;
   // const tags = field.input.value || [];
    const [tags, setTags] = useState(field.input.value || []);
    const [errorTag, setErrorTag] = useState(null)
    const [validationError, setValidationError] = useState({
        type: null,
        text: ""
    })

    const resetValidationError = () => {
        setValidationError({ type: null, text: "" });
        if(validationError.type=="duplicate")
        {
            var elList = document.querySelectorAll(".tag-wrapper");
            elList.forEach(function (el) {
                    removeClass(el, "ReactTags__tag__sametag");
            });
        }
    }

    useEffect(() => {
      window.__isReactDndBackendSetUp = false;
    }, []); 
    useEffect(() => {
     field.meta.initial&& field.meta.initial.length>0&&  setTags(field.meta.initial);
    }, [field.meta.initial]);

    useEffect(() => {
        if (tags.length) {
            setFullInputWidth();
        } else {
            setFullInputWidth(true)
        }
    }, [tags])

    const setFullInputWidth = (isFull = false) => {
        const wrapper = document.querySelector(".formTags .ReactTags__tags.react-tags-wrapper").getBoundingClientRect();
        const inputEl = document.getElementById("formTags_input")
        inputEl.placeholder = "";
        if (field.isDisabled) {
            inputEl.disabled = true;
            inputEl.placeholder = "";
            document.querySelector(".formTags .ReactTags__tags.react-tags-wrapper").className += " react-tag-disabled"
            document.querySelector(".formTags .ReactTags__tagInput").style.display = "none";
        }
         
         if (tags.length==0) {
            inputEl.placeholder = "Choose a Skillset";
        }

        if (isFull) {
            inputEl.style.width = wrapper.width - 5 + "px";
            return;
        }

        const lastTagRight = document.querySelector(".formTags .tag-wrapper.ReactTags__tag:last-of-type").getBoundingClientRect().right;
        field.isDisabled ? document.querySelector(".formTags .tag-wrapper.ReactTags__tag:last-of-type").className += " disabled" : null;
        const wrapperRight = wrapper.right

        const newWidth = (wrapperRight - lastTagRight) - 8
        inputEl.style.width = (newWidth > 92 ? newWidth : (wrapper.width - 5)) + "px";
    }



    const handleTagAddition = (newTag) => {
        const newTags = [...tags, newTag]

        if (tags.some(tag => tag.text == newTag.text) || (field.systemTags && field.systemTags.includes(newTag.text))) {
            setValidationError({
                type: "duplicate",
                text: "Cannot add duplicate, Tag already exists."
            })

            var elList = document.querySelectorAll(".tag-wrapper");
            elList.forEach(function (el) {
                if (el.innerText == newTag.text) {
                    setErrorTag(el)
                    addClass(el, "ReactTags__tag__sametag")
                    return false;
                }
            });
        } else if (newTag.text.length > 50) {
            setValidationError({
                type: "maxLength",
                text: field.input.name == "todo_tag" ? "Skillset should have up to a maximum of 50 characters." : "Tag should have up to a maximum of 50 characters."

            })
            return false;
        } else if (field.maxskillSet && tags.length >= field.maxskillSet) {
            setValidationError({
                type: "maxSkillSet",
                text: `Maximum ${field.maxskillSet} Skillset is allowed.`
            })
            return false;
        }
        else if(field.isOrgSkillSet) {
            resetValidationError();
            field.addTagForOrg(newTag);
            setTags(newTags);
        }
        else{
            resetValidationError();
            setTags(newTags);
            field.input.onChange(newTags);
         }
    }

    const handleInputChange = (value) => {
        if (validationError.type) {
            resetValidationError();
        }
        if (validationError.type === "duplicate") {
            removeClass(errorTag, "ReactTags__tag__sametag")
            setErrorTag(null)
        }

        const inputEl = document.getElementById("formTags_input")
        if (inputEl) {
            let width = getInputWidth(inputEl, "ReactTags__tmp_element")
            if (width > inputEl.getBoundingClientRect().width)
                inputEl.style.width = (width < 92 ? 92 : width) + "px";
        }
    }

    const handleDelete = (i) => {
        if (field.hasOwnProperty('isDisabled') && field.isDisabled) { return }
        if(field.isOrgSkillSet)
        {
            field.removeTagForOrg(tags.filter((tag, index) => index == i)[0]);
            setTags(tags.filter((tag, index) => index !== i));
        }
        else{
            setTags(tags.filter((tag, index) => index !== i));
           field.input.onChange(tags.filter((tag, index) => index !== i));
        }
    }

    const handleInputBlur = (text) => {
        if (text.trim().length) {
            handleTagAddition({
                "id": text,
                "text": text
            })
        }
    }

    const handleInputFocus = () => {
        if (isError) {
            resetValidationError();
        }
    }

    const isError = (field.meta.touched && field.meta.error) || validationError.text.length > 0

    return (
        <div className={`${field.formGroup ? field.formGroup : 'formGroup formTags colFlex'} ${field.wrapperClass ? field.wrapperClass : ''} ${(field.meta.touched && field.meta.error || isError) ? 'errorMsg' : ''}`}>
            {field.label && <div className={`${field.labeldivclass}`}><label>{field.label}{field.isRequired && <sup>*</sup>}
                {field.helpText && <span className="quickTooltip-bottom" data-quicktooltip={field.helpText}><Icon name="info" className="icon ml greyInfoIcon" /></span>}
            </label></div>}
            {field.systemTags && field.systemTags.length > 0 && <div className="rowFlex mb__8 flexWrap">
                {field.systemTags.map((sysTag, i) => (
                    <span key={i} className="ReactTags__tag disabled">
                        {sysTag}
                    </span>
                ))}
            </div>}
            <div className={`${field.tagclass} ${field.isDisabled ? "disabled" : ""}`} >
                <ReactTags
                    tags={tags}
                    suggestions={suggestions.filter(itm =>
                        itm?.text &&
                        !tags.some(tag =>
                            (tag?.text || "").toLowerCase() === itm.text.toLowerCase()
                        )
                    )}
                    id="formTags_input"
                    handleTagClick={handleDelete}
                    handleDelete={handleDelete}
                    removeComponent={removeComponent}
                    handleAddition={handleTagAddition}
                    handleInputChange={handleInputChange}
                    handleInputBlur={handleInputBlur}
                    handleInputFocus={handleInputFocus}
                    allowDragDrop={false}
                    allowUnique={false}
                    autofocus={false}
                    minQueryLength={1}
                />

                {isError &&
                    <span className="tag_error">{validationError.text.length ? validationError.text : field.meta.error}</span>
                }
            </div>
        </div>
    );
}

const removeComponent = (props) => {
    const { tags, removeComponent, ...rest } = props;

    return (
        <span {...rest}>
            <Icon name="close" className="icon" />
        </span>
    )
}

export default FormTags;
